import { createSlice } from '@reduxjs/toolkit';

import { ThunkRequestStatus } from '@fora-monorepo/webapp-types';

import { getHelpPageContent, getPagesContent } from './contentThunks';
import { ContentState } from './types/index';

export const initialContentState: ContentState = {
  content: {
    ingressCostAndInvoice: null,
    ingressMarkups: null,
    ingressEmployments: null,
    ingressEmploymentsNoEmployments: null,
    ingressPayrolls: null,
    ingressPayrollsNoReports: null,
    ingressFileDashboardNoReports: null,
    faqListEmployments: [],
    faqListEmploymentsNoEmployments: [],
    faqListAddEmployment: [],
    faqListAddEmploymentReceiptStep: [],
    faqListUpdateEmployment: [],
    faqListUpdateEmploymentReceiptStep: [],
    faqListCostAndInvoice: [],
    faqListMarkups: [],
    faqListReportPayroll: [],
    faqListPayrolls: [],
    faqListPayrollsNoReports: [],
    faqListReportPayrollConfirmStep: [],
    faqListReportPayrollReceiptStep: [],
    faqListReportWithFile: [],
    faqListReportWithFileConfirmStep: [],
    faqListReportWithFileReceiptStep: [],
    faqListAddEmploymentPeriod: [],
    faqListAddEmploymentPeriodReceiptStep: [],
    faqListEditEmployee: [],
    faqListEditEmployeeReceiptStep: [],
    faqListAddEmployeePersonInfo: [],
    faqListAddEmployeeEmploymentPeriod: [],
    faqListAddEmployeeReceiptStep: [],
    faqListEditEmploymentPeriod: [],
    faqListEditEmploymentPeriodReceiptStep: [],
    faqListEditParameter: [],
    faqListEditParameterReceiptStep: [],
  },
  help: {
    loadingContent: ThunkRequestStatus.Pending,
    content: {
      payrollsHelpPage: null,
      costAndInvoiceHelpPage: null,
      employmentsHelpPage: null,
      fileDashboardHelpPage: null,
    },
  },
  loadingContent: ThunkRequestStatus.Pending,
};

const contentSlice = createSlice({
  name: 'content',
  initialState: initialContentState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getPagesContent.fulfilled, (state, action) => {
      if (action.payload) {
        state.loadingContent = ThunkRequestStatus.Fulfilled;

        state.content = action.payload;
      }
    });
    builder.addCase(getPagesContent.pending, state => {
      state.loadingContent = ThunkRequestStatus.Pending;
    });
    builder.addCase(getPagesContent.rejected, state => {
      state.loadingContent = ThunkRequestStatus.Rejected;
    });
    builder.addCase(getHelpPageContent.fulfilled, (state, action) => {
      if (action.payload) {
        state.help.loadingContent = ThunkRequestStatus.Fulfilled;
        state.help.content[action.meta.arg.page] = action.payload;
      }
    });
    builder.addCase(getHelpPageContent.pending, state => {
      state.help.loadingContent = ThunkRequestStatus.Pending;
    });
    builder.addCase(getHelpPageContent.rejected, state => {
      state.help.loadingContent = ThunkRequestStatus.Rejected;
    });
  },
});

export const contentReducer = contentSlice.reducer;
export default contentSlice.reducer; // for unit tests
